/**
 * Input Schema of Faturamento
 * @author Thacryba
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {ExportarRelatorioFaturamento} from '@/model/resource/ExportarRelatorioFaturamento'

/* TODO: review generated schema */
export class InputExportarRelatorioFaturamentoSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  formFields = ['dataInicial', 'dataFinal', 'ehGrupoEconomico']

  readonly name = 'InputExportarRelatorioFaturamento'

  readonly fieldSet: FieldSet<ExportarRelatorioFaturamento> = {
    dataInicial: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'date',
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    dataFinal: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'date',
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    ehGrupoEconomico: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8 col-span-2',
        labelClass: 'relative state',
      },
    }),
  }
}
